import React, { createContext, useState, useContext, useCallback } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo.svg";
import styles from "./Navigation.module.css";

import { Language } from "../../../constants/sampleModels";
import am from "../../../assets/Flag_of_Armenia.svg.webp";
import en from "../../../assets/Flag_of_the_United_Kingdom.svg.webp";
const Navigation = ({ handleSetLocale }) => {
  const [toggle, setToggle] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const locale = localStorage.getItem("language") ?? "";
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  const changeLocale = (locale) => {
    setToggle(!toggle);
    handleSetLocale(locale);
    setIsOpen(!isOpen);
  };

  const closeToggles = () => {
    setToggle(!toggle);
    setIsOpen(false);
  };

  return (
    <nav className={styles.navigation}>
      <div className={styles.container}>
        <div className={styles.nav}>
          <Link to="/" className={styles.logo}>
            <img src={logo} alt="viewStruct logo" srcset="" />
          </Link>
          <div
            className={cn(styles.mobileMenu, menuOpen && styles.mobileMenuOpen)}
          >
            <a
              href="#features"
              className={styles.mobileLink}
              onClick={closeMenu}
            >
              Features
            </a>
            <a
              href="#benefits"
              className={styles.mobileLink}
              onClick={closeMenu}
            >
              Benefits
            </a>
            <a
              href="/Contact"
              className={styles.mobileLink}
              onClick={closeMenu}
            >
              Pricing
            </a>
          </div>
          <div className={styles.actions}>
            {/* <div className={styles.dropDownIconMenu}>
              <div
                className={styles.dropDownBtn}
                onClick={() => closeToggles()}
              >
                <button className="mt-1 dark:bg-gray-500 dark:border-gray-200">
                  aaaaaaaa
                </button>
              </div>
              <div
                className={cn(
                  toggle ? styles.navbarIconeButton : "",
                  styles.navBarDropDownBtn,
                )}
              >
                <div className="md:flex items-center space-x-3">
                  <button
                    type="button"
                    className={styles.buttonLeng}
                    id="user-menu-button"
                    aria-expanded="false"
                    aria-haspopup="true"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    {locale === Language.Hy ? (
                      <img src={am} alt="armenia" />
                    ) : (
                      <img src={en} alt="english" />
                    )}
                  </button>
                </div>
                {isOpen && (
                  <div
                    className={styles.languageContainer}
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="user-menu-button"
                    tabIndex={-1}
                  >
                    <div>
                      <button
                        onClick={() => changeLocale(Language.En)}
                        className="dark:bg-gray-500 dark:border-gray-500 flex items-center justify-center"
                      >
                        <img src={en} alt="english" />
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={() => changeLocale(Language.Hy)}
                        className="dark:bg-gray-500 dark:border-gray-500 flex items-center justify-center"
                      >
                        <img src={am} alt="dutch" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div> */}
            <a href="/signin" className={styles.signInBtn}>
              Sign In
            </a>

            <button
              type="button"
              className={cn(styles.menuBtn, menuOpen && styles.menuBtnOpen)}
              onClick={() => setMenuOpen((o) => !o)}
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            {/* <a href="/signUp" className={styles.heroBtn}>
              Start Free Trial
            </a> */}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
